module.exports = __webpack_public_path__ + "public/img/round.16574c18.png";